"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var victory_1 = require("victory");
var victory_2 = require("victory");
var react_sizeme_1 = require("react-sizeme");
var metrics_engine_1 = require("@tableau/metrics-engine");
/**
 * `SparkLine` renders the given data in a spark line suitable for display in list-view
 * or card style components.
 *
 * The spark line will fill provided `size` props. If you don't know the exact size, use `ResizableSparkLine`.
 *
 * If no data is provided, an empty div will be returned.
 *
 * If no stoke width is provided, the default value is `1`.
 *
 * @param props
 */
var SparkLine = /** @class */ (function (_super) {
    __extends(SparkLine, _super);
    function SparkLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SparkLine.prototype.render = function () {
        var _a, _b;
        var domain = metrics_engine_1.measureDomainToRender(this.props.data, metrics_engine_1.maxPrecision(this.props.formatString));
        return (React.createElement("div", { "data-tb-test-id": this.props.testId || 'sparkline', style: __assign({}, this.props.style) }, this.props.data.length > 0 && React.createElement(victory_1.VictoryChart, { height: this.props.size.height, width: this.props.size.width, padding: 0, domainPadding: { x: [0, 3], y: 3 }, domain: { y: domain }, singleQuadrantDomainPadding: false, containerComponent: React.createElement(victory_2.VictoryContainer, { responsive: false, style: {
                    labels: { fill: 'none' },
                } }) },
            React.createElement(victory_1.VictoryAxis, { crossAxis: false, style: {
                    tickLabels: { fill: 'none' },
                    axisLabel: { fill: 'none' },
                    axis: { stroke: 'none' },
                }, standalone: false, orientation: 'bottom' }),
            React.createElement(victory_1.VictoryAxis, { dependentAxis: true, crossAxis: false, style: {
                    grid: { stroke: 'none' },
                    tickLabels: { fill: 'none' },
                    axis: { stroke: 'none' },
                } }),
            React.createElement(victory_1.VictoryLine
            // `data` isn't typed as readonly, hence this cast
            , { 
                // `data` isn't typed as readonly, hence this cast
                data: this.props.data, 
                // @ts-ignore: Victory doesn't allow data accessor functions to return Date or undefined. This is fixed in version 34.2.0.
                x: this.props.timestampAccessor, y: this.props.measureAccessor, style: {
                    data: {
                        stroke: (_a = this.props.color, (_a !== null && _a !== void 0 ? _a : metrics_engine_1.MetricsNeutralColor)),
                        strokeWidth: this.props.strokeWidth !== undefined ? this.props.strokeWidth : 1,
                    },
                    labels: { fill: 'none' },
                } }),
            React.createElement(victory_1.VictoryScatter, { data: [this.props.data[this.props.data.length - 1]], style: { data: { fill: (_b = this.props.color, (_b !== null && _b !== void 0 ? _b : metrics_engine_1.MetricsNeutralColor)) } }, size: 3, 
                // @ts-ignore: Victory doesn't allow data accessor functions to return Date or undefined. This is fixed in version 34.2.0.
                x: this.props.timestampAccessor, y: this.props.measureAccessor }))));
    };
    SparkLine.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.data !== nextProps.data ||
            this.props.size.width !== nextProps.size.width ||
            this.props.size.height !== nextProps.size.height ||
            this.props.strokeWidth !== nextProps.strokeWidth;
    };
    return SparkLine;
}(React.Component));
exports.SparkLine = SparkLine;
/**
 * `ResizableSparkLine` renders the given data in a spark line suitable for display in list-view
 * or card style components.
 *
 * By default, the sparkline will fill whatever container it is placed in.
 *
 * If no data is provided, an empty div will be returned.
 *
 * If no stoke width is provided, the default value is `1`.
 *
 * @param props
 */
exports.ResizableSparkLine = react_sizeme_1.withSize({ monitorHeight: true, monitorWidth: true })(SparkLine);
//# sourceMappingURL=SparkLine.js.map